export default "__VITE_ASSET__CbHOg14R__"